import React, {ReactElement} from 'react';
import DateTimeFormatted from '../../../../../../components/DateTimeFormatted';
import MessageAgeInMinutes from '../../../../../../components/MessageAgeInMinutes';
import {
    ComparisonOperator,
    VehicleCharacteristic
} from '../../../../../../interfaces/GeoJsonSources/GeoJsonPropertiesSituation';
import {Props} from './Props';

class DialogSituationOnda extends React.Component<Props> {
    private static convertVehicleObstructionType(value: string): string {
        switch (value) {
            case 'brokenDownVehicle':
                return 'Auto met pech';
            case 'brokenDownHeavyLorry':
                return 'Vrachtwagen met pech';
            case 'roadClosed':
                return 'Weg afgesloten';
            default:
                return value;
        }
    }

    private static convertToReadableComparison(value: ComparisonOperator): string {
        switch (value) {
            case 'EQUAL_TO':
                return 'is';
            case 'GREATER_THAN':
                return 'is groter dan';
            case 'GREATER_THAN_OR_EQUAL_TO':
                return 'is groter dan of gelijk aan';
            case 'LESS_THAN':
                return 'is kleiner dan';
            case 'LESS_THAN_OR_EQUAL_TO':
                return 'is kleiner dan of gelijk aan';
            default:
                return 'onbekend';
        }
    }

    private static convertToReadableVehicleComparisionType(value: string): string {
        switch (value) {
            case 'FuelType':
                return 'Brandstof';
            case 'VehicleType':
                return 'Voertuig';
            case 'Weight':
                return 'Gewicht';
            case 'Width':
                return 'Breedte';
            case 'Length':
                return 'Lengte';
            case 'Height':
                return 'Hoogte';
            default:
                return value;
        }
    }

    private static convertVehicleValueToReadable(value: string): string {
        switch (value) {
            case 'agriculturalVehicle':
                return 'Landbouwvoertuig';
            case 'anyVehicle':
                return 'Elk voertuig';
            case 'bicycle':
                return 'Fiets';
            case 'bus':
                return 'Bus';
            case 'car':
                return 'Auto';
            case 'carWithTrailer':
                return 'Auto met aanhanger';
            case 'constructionOrMaintenanceVehicle':
                return 'Bouw- of onderhoudsvoertuig';
            case 'lorry':
                return 'Vrachtwagen';
            case 'moped':
                return 'Licht motorvoertuig';
            case 'motorcycle':
                return 'Motorfiets';
            case 'motorscooter':
                return 'Scooter';
            case 'van':
                return 'Personenwagen';
            case 'vehicleWithTrailer':
                return 'Voertuig met aanhanger';
            default:
                return value;
        }
    }

    render(): ReactElement {
        const {properties, showRecordIds} = this.props;

        return (
            <>
                <table>
                    <tbody>
                        {showRecordIds && (
                            <tr>
                                <th>ID</th>
                                <td>{properties.id}</td>
                            </tr>
                        )}
                        <tr>
                            <th>Tijd melding</th>
                            <td>
                                <DateTimeFormatted dateTime={properties.overallStartTime} />
                            </td>
                        </tr>
                        <tr>
                            <th>Bron</th>
                            <td>{properties.source}</td>
                        </tr>
                        <tr>
                            <th>Locatie</th>
                            <td>
                                {/* tslint:disable-next-line:max-line-length */}
                                {properties.primaryLocationDescription}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table>
                    <tbody>
                        <tr>
                            <th>Soort</th>
                            <td>{properties.type}</td>
                        </tr>
                        <tr>
                            <th>Sub type</th>
                            <td>{DialogSituationOnda.convertVehicleObstructionType(properties.subType)}</td>
                        </tr>
                        <tr>
                            <th>Tijd melding</th>
                            <td>
                                <DateTimeFormatted dateTime={properties.overallStartTime} />
                            </td>
                        </tr>
                        <tr>
                            <th>Tijd laatste aanpassing</th>
                            <td>
                                <DateTimeFormatted dateTime={properties.versionTime} />
                            </td>
                        </tr>

                        <tr>
                            <th>Tijd melding</th>
                            <td>
                                <MessageAgeInMinutes time={properties.overallStartTime} />
                            </td>
                        </tr>
                        {properties.forVehiclesWithCharacteristicsOf && (
                            <tr>
                                <th>Betrokken voertuig</th>
                                <td>
                                    <ul>
                                        {(JSON.parse(String(properties.forVehiclesWithCharacteristicsOf)) as unknown as VehicleCharacteristic[]).map((vehicleCharacteristic) => (
                                            <li key={vehicleCharacteristic.type}>{DialogSituationOnda.convertToReadableVehicleComparisionType(vehicleCharacteristic.type)} {DialogSituationOnda.convertToReadableComparison(vehicleCharacteristic.comparisonOperator)} {DialogSituationOnda.convertVehicleValueToReadable(vehicleCharacteristic.value)}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        )}
                        <tr>
                            <th>Melder</th>
                            <td>{properties.reporter}</td>
                        </tr>
                        <tr>
                            <th>Melder referentie</th>
                            <td>{properties.reporterReference}</td>
                        </tr>
                        <tr>
                            <th>Bergingsstatus</th>
                            <td>{this.convertMobilityOfObstruction(properties.mobilityOfObstruction)}</td>
                        </tr>
                    </tbody>
                </table>
            </>
        );
    }

    private convertMobilityOfObstruction = (value: string): string => {
        if (value === 'stationary') {
            return 'Stilstaand';
        } else {
            return value;
        }
    };
}

export default DialogSituationOnda;
